import { css } from "@compiled/react";

import { RichTextComponent } from "@/libraries/design/utils/rich-text/src/rich-text.tsx";

import { richTextToHTML } from "../../../../../clients/uniform-client/enhancers/utils.ts";
import { PlanFields } from "../types.ts";

export const getFeaturesList = (
    highlightedFeaturesContainer?: PlanFields["highlightedFeaturesContainer"]
) => {
    if (!highlightedFeaturesContainer?.length) {
        return undefined;
    }

    return highlightedFeaturesContainer?.map((feature) => ({
        label: feature.fields.highlightedFeatureTitleExternal,
        details: feature.fields.highlightedFeatureDetails && (
            <div css={featureDetailsCss}>
                <RichTextComponent
                    text={richTextToHTML(
                        feature.fields.highlightedFeatureDetails
                    )}
                />
            </div>
        ),
        lozengeText: feature.fields.highlightedLabel
    }));
};

const featureDetailsCss = css({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    p: {
        fontSize: "14px"
    }
});
